export const getErrorText = type => {
    if (type === 'url') {
        return 'This value should be a valid url.';
    }
};

export const getUrlMatchRegex = () =>
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9-_%#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export const addProtocol = url => {
    const hasProtocolCheck = /^https?:\/\//;
    const hasProtocol = hasProtocolCheck.exec(url);

    if (!hasProtocol) {
        return `https://${url}`;
    }
    return url;
};
